var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-container"},[_c('div',{staticClass:"sub-contents"},[_c('img',{attrs:{"src":'/api/main/bnr/image?attaType=01&bannerSeq='+_vm.$route.query.bannerSeq}})])])}
var staticRenderFns = []

export { render, staticRenderFns }